<template>
    <div >
        <div class="chart-legend">
            <span class="red">自然板家数:<b class="red">{{legend.ztjs}}家</b></span>
            <span class="org">触及涨停:<b class="org">{{legend.cjzt}}家</b></span>
            <span class="red">封板率:<b class="red">{{legend.fbl}}</b></span>
        </div>
        <div class="chart-wrap" id="fblMonth-echart-container"><p class="blank">-- 暂无数据 --</p></div>
    </div>
</template>

<script>
    import date from '@/utils/date.js'
    import { mapState } from 'vuex'
    export default {
        data:function(){
            return {
                isHelp:false,
                legend:{ztjs:"--",cjzt:"--",fbl:"--"},
                chartData:{time:[],ztjs:[],cjzt:[]},
            }
        },
        computed: {
            ...mapState(['isBlankPage'])
            //this.BlankPage;
        },
        mounted:function(){
            this.getMarkettrendKlineInfo();
        },
        methods: {
            toggle: function () {
                this.isHelp =! this.isHelp;
            },
            getMarkettrendKlineInfo:function () {
                var _this=this;
                dzhyun.query('/markettrend/index/kline', { obj:'SH000001,SZ399001',start:'-30' }, function(data) {
                    //...
                }).then(function(data) {
                    _this.handleGetMarkettrendKlineSucc(data);
                }).catch(function(err) {
                    //...
                });
            },
            handleGetMarkettrendKlineSucc:function(res) {
                if(res.length>0){
                    for(var i=0;i<30;i++){
                        var time                        = new Date(res[0].Data[i].ShiJian*1000);;
                        this.chartData.time[i]    =date.formt(new Date(time),"MM/dd");
                        this.chartData.ztjs[i]    =res[0].Data[i].ZuiXinJiaDengYuZhangTingJiaShu;//跌停家数
                        this.chartData.cjzt[i]    =res[0].Data[i].ZuiGaoJiaDengYuZhangTingJiaShu;//触及涨停
                    }
                    var ztjs      = res[0].Data[res[0].Data.length - 1].ZuiXinJiaDengYuZhangTingJiaShu;
                    var cjzt      = res[0].Data[res[0].Data.length - 1].ZuiGaoJiaDengYuZhangTingJiaShu;
                    var fbl       = res[0].Data[res[0].Data.length - 1].FengBanLv+"%";
                    this.legend     = {ztjs:ztjs,cjzt:cjzt,fbl:fbl};
                    if(!this.isBlankPage && this.chartData.time.length>0 && this.chartData.ztjs.length>0 && this.chartData.cjzt.length>0){
                        this.myChart();
                    }
                }
            },
            myChart:function(){
                var _this=this
                // 基于准备好的dom，初始化echarts实例
                var echart = echarts.init(document.getElementById('fblMonth-echart-container'),'white');
                // 指定图表的配置项和数据
                var option = {
                    backgroundColor: '#FFFFFF',
                    title: {
                        show: true,
                        //text: '沪深涨跌停走势',
                        textStyle: {
                            color: '#222',
                            fontSize: 12,
                            fontWeight: 'normal'
                        },
                        z: 2,
                        left: 30,
                        top: '-5px'
                    },
                    tooltip: {
                        trigger: 'axis',
                        backgroundColor: '#406cc2',
                        textStyle: {
                            color: "#fff",
                            fontSize: 12
                        },
                        position: function (point) {
                            // 固定在顶部
                            // return [point[0], '0'];
                        },
                        padding: [5, 10],
                        confine: true,
                        formatter: function (params) {
                            var string = '';
                            if (!isNaN(params[0].value)) {
                                string += '自然板家数:' + params[0].value + '家<br/>';
                            }
                            if (!isNaN(params[0].value)) {
                                string += '触及涨停:' + params[1].value + '家<br/>';
                            }
                            return (string == '') ? false : params[0].name + '<br/>' + string;
                        },
                        axisPointer: {
                            lineStyle: {color: '#406cc2'},
                        }
                    },
                    color: ['#FF0000','#fd8824'],
                    grid: {
                        left: 10,
                        right: 30,
                        top: 20,
                        bottom: 10,
                        containLabel: true
                    },
                    dataZoom: [{
                        type: 'slider',
                        show: false
                    }],
                    xAxis: {
                        type: 'category',
                        axisLabel: {
                            interval: 6,
                            textStyle: {fontSize: 13},
                            formatter: null
                        },
                        axisTick:{
                            show:false //是否显示坐标轴刻度
                        },
                        data: _this.chartData.time
                    },
                    yAxis: {
                        type: 'value',
                        scale: true,
                        axisLine: {
                            show: false
                        },
                        axisTick: {
                            show: false
                        },
                        axisLabel: {
                            margin: 2,
                            textStyle: {fontSize: 13}
                        },
                        splitLine: {
                            show: true,
                            lineStyle: {}
                        },
                        splitNumber: 3,
                    },
                    series: [
                        {
                            name: '自然板家数',
                            type: 'line',
                            smooth: true,
                            showSymbol: false,
                            symbol: 'circle',
                            symbolSize: 3,
                            z: 100,
                            itemStyle: {
                                normal: {
                                    borderColor: 'rgba(62, 106, 197, 0.5)',
                                    borderWidth: 5
                                }
                            },
                            data: _this.chartData.ztjs
                        },
                        {
                            name: '触及涨停',
                            type: 'line',
                            smooth: true,
                            showSymbol: false,
                            symbol: 'circle',
                            symbolSize: 3,
                            z: 100,
                            itemStyle: {
                                normal: {
                                    borderColor: 'rgba(253, 136, 36, 0.5)',
                                    borderWidth: 5
                                }
                            },
                            data: _this.chartData.cjzt
                        }
                    ]
                };
                echart.setOption(option);
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/pages/home/components/fblMonth.vue